/* eslint-disable import/prefer-default-export */
import axios from '../../axios';

// ---------------------------------------------------------------------------
// RH / Recrutamento & Seleção — Relatório do processo (service layer, 0061).
//
// Consumido dentro da ficha da vaga (fatia 2). Sem paginação. Permissão:
// hr:candidate:read. report = { job_opening_id, total, by_stage:{STAGE:n},
// by_outcome:{OUTCOME:n} }.
// ---------------------------------------------------------------------------

export async function getOpeningReport(jobOpeningId) {
   const response = await axios.get(
      `/hr/recruitment/reports/opening/${jobOpeningId}`,
   );
   return response?.data?.data?.report ?? null;
}
